import httpClient from "../httpClient";

export const getDs82BotStatus = () => httpClient.get("/ds82/bot-status");
